import DialogTemplate from './DialogTemplate'

export default DialogTemplate
